import * as S from './styles'
import { Text, TextProps } from '../text'

export type TextWithHighlightedProps = TextProps & {
  text: string
  colorHighlighted?: string
}
export const TextWithHighlighted: React.FC<TextWithHighlightedProps> = ({
  text,
  size,
  colorHighlighted,
  ...rest
}) => {
  const newText = text.split('*').map((tex, i) => {
    if (i % 2 !== 0) {
      return (
        <S.HighlightedText key={tex} color={colorHighlighted}>
          {tex}
        </S.HighlightedText>
      )
    }
    return tex
  })

  return (
    <Text size={size} {...rest}>
      {newText.map((newTex) => newTex)}
    </Text>
  )
}
